import { InformationalModalContextType } from '../types/InformationalModalContextType';

export const informationalModalInitValue: InformationalModalContextType = {
  data: {
    alias: 'OP_ALIAS_CANJE',
    date: '',
    comments: '',
    file: undefined,
    selectedParticipants: [],
    participantOptions: [],
    isForAllPartners: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeAlias(): void {},
    handleChangeDate(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    handleToggleForAllPartners(): void {},
    handleChangeParticipants(): void {},
    handleSaveInformational(): void {},
  },
};
